import React from 'react';

const NotFound: React.FC = () => {
    return (
        <div>
            <h1 className="ontario-margin-top-0-! ontario-margin-bottom-16-!">404 - Page Not Found</h1>
            <p>We are sorry, but the page you requested was not found.</p>
        </div>
    );
};

export default NotFound;